import { put, takeEvery, all, putResolve } from "redux-saga/effects";
import { CFTNS } from "../auth/actionsType";
import { TIMEOUT } from "../../api/api"
import { ricercaComuniAction, ricercaComuniActionSuccess, ricercaIscrizioneActionSuccess } from "./actions";
import { ERROR, LOADING, LOADING_BLOCKING } from "../../global/statusLabels";
import { RICERCA_COMUNI, RICERCA_ISCRIZIONE } from "./actionsType";
import { isAuthenticatedActionSuccess } from "../auth/actions";
import { EXPIRATION_TIME } from "../../auth/authFunctions";
import { setMessaggioAction } from "../messaggio/actions";
import { ERRORE_ASR, ERRORE_BLOCKING, ERRORE_GENERICO_API, ERRORE_SESSION_EXPIRED, } from "../../global/messaggioLabels";
import { getProfiloAriannaAction } from "../screening/actions";
import { ricercaComuniApiSPID, ricercaComuniApiTS, ricercaIscrizioneApiSPID, ricercaIscrizioneApiTS } from "../../api/apiFunctionsAnagrafe";
import { generaLog } from "../../functions/utils";

function* ricercaIscrizioneWorker() {
    generaLog("ricercaIscrizioneWorker", "log")
    yield put(ricercaIscrizioneActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: + TIMEOUT }))
    let response;
    try {
        if (sessionStorage.tempCFTNS || sessionStorage.CFTNS) {
            response = yield ricercaIscrizioneApiTS()

        } else {
            response = yield ricercaIscrizioneApiSPID()
        }
        if (response?.status === 200) {
            //CFTNS -> è la sua login
            if (sessionStorage.tempCFTNS) {
                sessionStorage.setItem("CFTNS", sessionStorage.tempCFTNS)
                sessionStorage.setItem("expirationDate", new Date().getTime() + EXPIRATION_TIME)
                sessionStorage.removeItem("tempCFTNS")
                yield put(isAuthenticatedActionSuccess({ isAuthenticated: true, authType: CFTNS }))
            }
            //yield put(resetMessaggioStateAction())
            yield put(ricercaIscrizioneActionSuccess({ value: response?.data, status: response?.status }))
            yield putResolve(ricercaComuniAction(response.data?.DatiMinimiIscrizione?.CodiceAreaAssistenza ?? response?.data?.DatiMinimiIscrizione?.CodiceAslAssistenza))
            yield putResolve(getProfiloAriannaAction())

        }
        else {
            yield put(setMessaggioAction({ status: ERRORE_ASR }))
        }
    } catch (error) {
        yield put(ricercaIscrizioneActionSuccess({ value: error?.response?.data ?? ERROR, status: error?.response?.status ?? ERROR }))
        if (error?.response?.status === 404 || error?.response?.status === 401)
            yield put(setMessaggioAction({ status: ERRORE_ASR }))
        else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_BLOCKING }))
        }
    }

}

function* ricercaIscrizioneWatcher() {
    yield takeEvery(RICERCA_ISCRIZIONE, ricercaIscrizioneWorker);
}

function* ricercaComuniWorker(aslId) {
    generaLog("ricercaComuniWorker", "log")
    yield put(ricercaComuniActionSuccess({ value: undefined, status: LOADING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield ricercaComuniApiTS(aslId.aslId)
        } else {
            response = yield ricercaComuniApiSPID(aslId.aslId)
        }

        if (response?.status === 200) {
            // aggiungiamo valore nullo all'array Comuni
            const array = response?.data;
            array.Comuni.push({ NomeComune: '--', CodIstat: '00', Distretto: 0 })
            yield put(ricercaComuniActionSuccess({ value: array, status: response?.status }))
        }
    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {

            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(ricercaComuniActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}
function* ricercaComuniWatcher() {
    yield takeEvery(RICERCA_COMUNI, ricercaComuniWorker);
}

export function* anagrafeWatchers() {
    yield all([
        ricercaIscrizioneWatcher(),
        ricercaComuniWatcher(),

    ]);
}